import React from 'react'
import Table from './KmlTable'
import LoaderDots from "./../../../Modal/components/LoaderDots"

const getClassFileSelect = (props) => {
  let className = 'kml-input-form-bottons on-mouse-hover '
  if (props.file) return className + 'green-background-color'
  else {
    className = className + 'gray-background-color '
  }
  if (props.fileError) return className + 'border-error-color'
  return className
}

const KmlComponent = (props) => {
  const { state } = props
  return (
    <>
      <input
        id='kml-input-file'
        type="file"
        accept=".kml, .kmz"
        style={{ display: 'none' }}
        onChange={props.fileChange}
      ></input>
      <div style={{ minHeight: '205px' }}>
        <div className="modal-title-header">
          <div className='title-modal-kml-input no-select'>Agregar Capa</div>
          <div className='add-button'><i className="fas fa-times on-mouse-hover" onClick={props.close}></i></div>
        </div>
        <div className="search-container">
          <div className="kml-file-input-form">
            <div className={(state.nameError && !state.name) ? 'kml-container-input border-error-color' : 'kml-container-input'}>
              <input
                placeholder='nombre'
                type="text"
                className="kml-input"
                value={state.name}
                onChange={props.handlerText}
              />
            </div>
            <div onClick={props.fileSelect} className={getClassFileSelect(state)} title={state.file ? state.file.name : ''} >
              <i className="far fa-file"></i>
            </div>
            <div onClick={props.uploadFile} className='kml-input-form-bottons primary-background-color on-mouse-hover'>
              <i className="fas fa-save"></i>
            </div>
          </div>
        </div>
        <div className='dots-height'>
          {state.loading && <LoaderDots />}
          {state.upload ? (state.uploadOk ? <div className='text-center green-color'>Cargado con exito</div> : <div className='text-center red-color'>Error en la acción</div>) : <></>}
        </div>
      </div>
      {
        !!state.tableContent.length &&
        <>
          <Table
            content={state.tableContent}
            activate={props.activateLayer}
            dobleClick={props.dobleClickTextHandler}
            update={props.updateLayer}
            cancel={props.cancelLayer}
            delete={props.deleteLayer}
          />
        </>
      }
    </>
  )
}

export default KmlComponent;